import type {
  RemoteCacheClient,
  RemoteCacheClientOperationResult,
  RemoteCacheClientUploadOperationOptions,
} from '@ms-cloudpack/remote-cache';
import type { Task } from '../types/Task.js';

export function createUploadTask(inputs: {
  options: RemoteCacheClientUploadOperationOptions;
  client: RemoteCacheClient;
}): Task<RemoteCacheClientOperationResult> {
  const { client, options } = inputs;

  const { friendlyName, id } = options;
  return {
    id: `upload-${id}`,
    name: `Upload ${friendlyName}`,
    execute(): Promise<RemoteCacheClientOperationResult> {
      return client.uploadFolder(options);
    },
  };
}
